import { ITweet } from 'components/ui/tweet/types'

import cnLogo from './icons/cn-logo.png'
import guardaLogo from './icons/guarda-tweet-logo.jpg'
import nowNodesLogo from './icons/nowNodes-tweet-logo.png'

export const tweets: ITweet[] = [
  {
    tweetId: '1333812652561338369',
    authorName: 'ChangeNOW',
    authorId: 'ChangeNOW_io',
    logo: cnLogo,
    text:
      'Looking to diversify you portfolio, but still want to #HODL? 🤔\n' +
      'Leave your bag alone, get a loan for your ongoing costs from our new partner \n' +
      '@CoinRabbitLoans\n' +
      ' 🐰\n',
    likes: 3,
    comments: 0,
    date: '7:38 PM · Dec 1, 2020',
  },
  {
    tweetId: '1333830077629538315',
    authorName: 'Guarda',
    authorId: 'GuardaWallet',
    logo: guardaLogo,
    text:
      "Check out Guarda's partner service \n" +
      '@CoinRabbitLoans\n' +
      ' that lets you get unlimited term loans for just 5% APR 😉🙏',
    likes: 5,
    comments: 1,
    date: '8:47 PM · Dec 1, 2020',
  },
  {
    tweetId: '1653380176032546820',
    authorName: 'NOWNodes',
    authorId: 'NOWNodes',
    logo: nowNodesLogo,
    text:
      "We always have open invitation for @CoinRabbitLoans - they're joining our gala as well 🐰 \n" +
      '\n' +
      'Rounds of praises for this exceptional Web3 tool for holders and investors. And we totally get it 😉',
    likes: 6,
    comments: 1,
    date: '3:45 PM · May 2, 2023',
  },
]
